import { updateLoadingCount } from '../reducer/CommonSlice'
import store from '../store'
import { fetchApi } from './fetch-services'

const baseURL = process.env.REACT_APP_BASE_API_URL

export const contractStructureGrid = async (data) => {
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/contract-comparison/getContractStructureGridValue`
  })

  return response
}

export const getContractComparision = async (data) => {
  store.dispatch(updateLoadingCount(true))
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/calculation_summary/getContractComparision`
  })
  store.dispatch(updateLoadingCount(false))
  return response
}

export const copyContractComparison = async (data) => {
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/calculation_summary/getCopyContractComparision`
  })
  return response
}

export const pollingContractComparison = async (data) => {
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/scenario/getContractComparisionStatus`
  })
  return response
}

export const getAccountOrCorporateParentFilter = async (data) => {
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/calculation_summary/getAccountOrCorporateParentFilter`
  })
  return response
}

export const getContractComparisionGraphData = async (data) => {
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/calculation_summary/getContractComparisionGraph`
  })

  return response
}

export const saveInterimWacPricing = async (data) => {
  const response = await fetchApi({
    header: {},
    data,
    method: 'POST',
    url: `${baseURL}/scenario/saveInterimWacPricing`
  })

  return response
}
